import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../api/api";

export default function MyTours() {
  const navigate = useNavigate();
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ================= FILTER STATE ================= */

  const [filters, setFilters] = useState({
  search: "",
  date: "all"
});

  

  /* ================= LOAD ================= */

  const load = async () => {
    try {
      setLoading(true);

      const res = await API.get("/coordinator/mine");

      setTours(
        Array.isArray(res.data)
          ? res.data
          : []
      );

    } catch (err) {

      console.error(
        "load my tours error:",
        err
      );

      setTours([]);

    } finally {

      setLoading(false);

    }
  };


const unassignTour = async (sessionId) => {
  const confirmed = window.confirm(
    "Are you sure you want to unassign this tour?"
  );

  if (!confirmed) return;

  try {
    await API.post(`/coordinator/unassign/${sessionId}`);

    await load();

  } catch (err) {

    console.error("UNASSIGN TOUR ERROR:", err);

    alert(
      err.response?.data?.error ||
      "Unable to unassign tour"
    );
  }
};

  useEffect(() => {
    load();
  }, []);


  /* ================= DATE FORMAT ================= */

  const formatDateTime = (dateString) => {

    if (!dateString) {
      return "No date";
    }

    const date =
      new Date(dateString);

    return date.toLocaleString(
      "en-GB",
      {
        weekday: "long",
        day: "2-digit",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      }
    );
  };


  /* ================= FILTER ================= */

  const filteredTours = useMemo(() => {

    return tours.filter((t) => {

      const matchSearch =
        t.title
          ?.toLowerCase()
          .includes(
            filters.search.toLowerCase()
          );

      const now =
        new Date();

      const tourDate =
        new Date(t.start_datetime);

      const matchDate =
        filters.date === "all"
          ? true
          : filters.date === "today"
          ? tourDate.toDateString() ===
            now.toDateString()
          : tourDate >= now;

      return (
        matchSearch &&
        matchDate
      );

    });

  }, [tours, filters]);


 

  /* ================= RENDER ================= */

  return (
    <div style={page}>

      {/* HEADER */}

      <div style={header}>

        <h2 style={title}>
          My Assigned Tours
        </h2>

        <p style={subtitle}>
          Your upcoming coordinator tours
        </p>

      </div>


      {/* FILTERS */}

      <div style={filterBar}>

        <input
          placeholder="Search tours..."
          value={filters.search}
          onChange={(e) =>
            setFilters((p) => ({
              ...p,
              search: e.target.value
            }))
          }
          style={input}
        />

        <select
          value={filters.date}
          onChange={(e) =>
            setFilters((p) => ({
              ...p,
              date: e.target.value
            }))
          }
          style={select}
        >

          <option value="upcoming">
            Upcoming
          </option>

          <option value="today">
            Today
          </option>

          <option value="all">
            All
          </option>

        </select>

        <button
          onClick={load}
          style={refreshBtn}
        >
          Refresh
        </button>

      </div>


      {/* LOADING */}

      {loading && (
        <div style={loadingBox}>
          Loading...
        </div>
      )}


      {/* EMPTY */}

      {!loading &&
        filteredTours.length === 0 && (
          <div style={emptyBox}>
            No tours found
          </div>
        )}


      {/* GRID */}

      <div style={grid}>

        {filteredTours.map((t) => {

          const booked =
            t.booked ?? 0;

          const capacity =
            t.capacity ?? 0;

          const fillPercent =
            capacity > 0
              ? Math.round(
                  (booked / capacity) * 100
                )
              : 0;

          return (

            <div
              key={t.id}
              style={card}
            >

              <div style={cardHeader}>

                <h3 style={tourTitle}>
                  {t.title}
                </h3>

                <span style={badge}>

                  {fillPercent >= 100
                    ? "Full"
                    : fillPercent >= 80
                    ? "Busy"
                    : "Active"}

                </span>

              </div>


              <div style={infoRow}>
                📅{" "}
                {formatDateTime(
                  t.start_datetime
                )}
              </div>


              <div style={infoRow}>
                👥 {booked} / {capacity}
              </div>


              <button
               onClick={() =>
    navigate(`/coordinator/tour/${t.id}`)
}
                style={detailsBtn}
              >
                📄 Details
              </button>

              {Number(booked) === 0 && (
  <button
    onClick={() => unassignTour(t.id)}
    style={unassignBtn}
  >
    ↩ Unassign Tour
  </button>
)}


              <div style={barBg}>

                <div
                  style={{
                    ...barFill,

                    width:
                      `${fillPercent}%`,

                    background:
                      fillPercent >= 100
                        ? "#ef4444"
                        : fillPercent >= 80
                        ? "#f59e0b"
                        : "#22c55e"
                  }}
                />

              </div>


              <p style={percentText}>
                {fillPercent}% filled
              </p>

            </div>

          );

        })}

      </div>


    

      

    </div>
  );
}


/* ================= STYLES ================= */

const page = {
  padding: 24,
  background: "#f8fafc",
  minHeight: "100vh"
};


const header = {
  marginBottom: 16
};


const title = {
  margin: 0,
  fontSize: 22,
  fontWeight: 700,
  color: "#0f172a"
};


const subtitle = {
  marginTop: 4,
  fontSize: 13,
  color: "#64748b"
};


const filterBar = {
  display: "flex",
  gap: 10,
  marginBottom: 18,
  flexWrap: "wrap"
};


const input = {
  padding: "10px 12px",
  borderRadius: 10,
  border: "1px solid #e2e8f0"
};


const select = {
  padding: "10px 12px",
  borderRadius: 10,
  border: "1px solid #e2e8f0"
};


const refreshBtn = {
  padding: "10px 14px",
  borderRadius: 10,
  border: "none",
  background: "#0ea5e9",
  color: "white",
  cursor: "pointer"
};


const loadingBox = {
  padding: 20,
  background: "#fff",
  borderRadius: 12,
  marginBottom: 16
};


const emptyBox = {
  padding: 30,
  textAlign: "center",
  background: "#fff",
  borderRadius: 12
};


const grid = {
  display: "grid",
  gridTemplateColumns:
    "repeat(auto-fill, minmax(280px, 1fr))",
  gap: 14
};


const card = {
  background: "white",
  borderRadius: 14,
  padding: 14,
  border: "1px solid #e2e8f0"
};


const cardHeader = {
  display: "flex",
  justifyContent: "space-between"
};


const tourTitle = {
  fontSize: 15,
  fontWeight: 600,
  margin: 0
};


const badge = {
  fontSize: 11,
  padding: "3px 8px",
  borderRadius: 999,
  background: "#dbeafe",
  color: "#1d4ed8"
};


const infoRow = {
  fontSize: 13,
  marginTop: 6
};


const detailsBtn = {
  marginTop: 10,
  width: "100%",
  padding: "8px",
  borderRadius: 8,
  border: "1px solid #ddd",
  background: "#f1f5f9",
  cursor: "pointer"
};


const barBg = {
  height: 8,
  background: "#e2e8f0",
  borderRadius: 999,
  overflow: "hidden",
  marginTop: 10
};


const barFill = {
  height: "100%",
  borderRadius: 999
};


const percentText = {
  fontSize: 12,
  marginTop: 6,
  color: "#64748b"
};

const unassignBtn = {
  marginTop: 8,
  width: "100%",
  padding: "8px",
  borderRadius: 8,
  border: "1px solid #fecaca",
  background: "#fef2f2",
  color: "#dc2626",
  fontWeight: 600,
  cursor: "pointer"
};
